import React, { useMemo } from 'react';
import { Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { selectApiUrls } from '../../redux/slices/apiUrlSlice';
import { useGetShippingScheduleQuery, refreshBackgroundQuery } from '../../redux/api/portalApi';
import OnHoldJobs from '../JobSchedulePage/OnHoldJobs';
import { normalizeShippingSchedule } from './shippingConfig';
import useShippingLiveUpdates from './useShippingLiveUpdates';

export default function ShippingOnHoldJobs() {
  const dispatch = useDispatch();
  const urls = useSelector(selectApiUrls);
  const schedule = useGetShippingScheduleQuery({ url: urls.fullSchedule, params: { jobStatus: 'Hold/ Ready to Ship' } }, { skip: !urls.fullSchedule, refetchOnMountOrArgChange: true });
  const jobs = useMemo(() => normalizeShippingSchedule(schedule.data), [schedule.data]);
  const live = useShippingLiveUpdates({ enabled: true, scope: urls.shipping, blocked: schedule.isFetching,
    refresh: (options) => urls.fullSchedule ? dispatch(refreshBackgroundQuery('getShippingSchedule',
      { url: urls.fullSchedule, params: { jobStatus: 'Hold/ Ready to Ship' } }, options)) : false });
  return <section className="job-schedule-page">
    <h2 className="h4">On Hold Ready to Ship</h2>
    {live.warning && <Alert variant="warning" dismissible onClose={live.dismissWarning}>{live.warning}</Alert>}
    {(!urls.fullSchedule || schedule.error) && <Alert variant="danger">Unable to load on hold jobs.</Alert>}
    {schedule.isFetching && <p role="status">Refreshing on hold jobs…</p>}
    <OnHoldJobs readyToShipOnly canEdit={false} suppliedJobs={jobs} />
  </section>;
}
